module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(2).fba8694d.png";